import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_payment_info
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackAddPaymentInfoItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackAddPaymentInfoParameters
    extends TrackEventListParameters<"coupon" | "currency" | "value" | "payment_type", null, TrackAddPaymentInfoItem> {}

const trackAddPaymentInfo = (parameters: TrackAddPaymentInfoParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "add_payment_info", ...parameters }, options);
};

export default trackAddPaymentInfo;
